import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { Header, Footer, Preloader } from './components';
import { HomePage } from './routes';
import { Config, ConfigProvider } from './config';
import { LightTheme, DarkTheme } from './theme/muiTheme';
import 'typeface-roboto';
import 'typeface-oswald';

const Events = lazy(() => import('./routes/Events'));
const Contact = lazy(() => import('./routes/Contact'));
const PrivacyPolicy = lazy(() => import('./routes/PrivacyPolicy'));

const useStyles = makeStyles((theme) => ({
  '@global': {
    '.root': {
      display: 'flex',
      padding: theme.spacing(2),
      minHeight: '75vh',
    },
  },
}));

function WaitingComponent(Component) {
  return (props) => (
    <Suspense fallback={<Preloader />}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Component {...props} />
    </Suspense>
  );
}

const useStateWithLocalStorage = (localStorageKey) => {
  const [themeSelected, setTheme] = React.useState(
    localStorage.getItem(localStorageKey) || true
  );

  React.useEffect(() => {
    localStorage.setItem(localStorageKey, themeSelected);
  }, [themeSelected, localStorageKey]);

  return [themeSelected, setTheme];
};

export default function App() {
  const classes = useStyles();
  const [themeSelected, setTheme] = useStateWithLocalStorage('theme');

  const themeSwitcher = () => {
    if (JSON.parse(themeSelected)) return LightTheme;
    return DarkTheme;
  };

  return (
    <ConfigProvider value={Config} className={classes.cfg}>
      <ThemeProvider theme={themeSwitcher()}>
        <CssBaseline />
        <Header switch={setTheme} status={JSON.parse(themeSelected)} />
        <Switch>
          <Route path="/" exact component={HomePage} />
          <Route
            path="/events/:regionName"
            component={WaitingComponent(Events)}
          />
          <Route
            path="/contact/:action"
            component={WaitingComponent(Contact)}
          />
          <Route path="/privacy" component={WaitingComponent(PrivacyPolicy)} />
        </Switch>
        <Footer />
      </ThemeProvider>
    </ConfigProvider>
  );
}
